import * as React from 'react';
import { Menus } from '@wix/restaurants-orders-components';
import type { IMenuListProps } from '../MenuList.props';
import classNames from 'classnames';
import styles from './MenuList.scss';

/**
 * As a rule of thumb, we use functional components, and use React's hooks and forwardRef for more advanced capabilities.
 * To learn more about React components guidelines, read [the code-guidelines](https://bo.wix.com/pages/editor-elements-docs/docs/development/contributing#code-guidelines)
 */
const MenuList: React.FC<IMenuListProps> = props => {
  return (
    <div className={classNames('root', styles.root)}>
      <Menus menus={props.menus} />
    </div>
  );
};

export default MenuList;
